import { APP_BRAND_MARK, APP_BRAND_TAIL } from "../../../utils/brand";

const CustomLoading = () => {
  return (
    <>
      <div className="main_loading_section"></div>
      <div className="loading_image">
        <div className="loading_brand">
          <div className="bm_logo_mark">{APP_BRAND_MARK}</div>
          <div className="loading_brand_text">{APP_BRAND_TAIL}</div>
          <div className="loading_spinner" />
        </div>
      </div>
    </>
  );
};

export default CustomLoading;
